import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Home = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.69292 7.86157C4.69292 7.50207 4.98435 7.21065 5.34384 7.21065H10.8347C11.1942 7.21065 11.4856 7.50207 11.4856 7.86157C11.4856 8.22106 11.1942 8.51249 10.8347 8.51249H5.34384C4.98435 8.51249 4.69292 8.22106 4.69292 7.86157Z"
        fill="currentColor"
      />
      <path
        d="M5.34384 9.78855C4.98435 9.78855 4.69292 10.08 4.69292 10.4395C4.69292 10.799 4.98435 11.0904 5.34384 11.0904H10.8347C11.1942 11.0904 11.4856 10.799 11.4856 10.4395C11.4856 10.08 11.1942 9.78855 10.8347 9.78855H5.34384Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.10429 2.58378C7.72097 2.11764 8.57512 2.12861 9.17963 2.61042L13.3624 5.94424C13.7653 6.26535 14 6.7525 14 7.26769V12.0661C14 13.0008 13.2423 13.7585 12.3076 13.7585H3.69239C2.75771 13.7585 2 13.0008 2 12.0661V7.28426C2 6.75381 2.24871 6.25404 2.67188 5.93418L7.10429 2.58378ZM8.36822 3.62846C8.22872 3.51727 8.03161 3.51474 7.8893 3.62231L3.45689 6.97271C3.35923 7.04652 3.30184 7.16185 3.30184 7.28426V12.0661C3.30184 12.2818 3.4767 12.4567 3.69239 12.4567H12.3076C12.5233 12.4567 12.6982 12.2818 12.6982 12.0661V7.26769C12.6982 7.1488 12.644 7.03638 12.551 6.96228L8.36822 3.62846Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Home;
